import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedDrawerStatus } from "@src/ducks/slices/dashboard.slice";
import React from "react";
import { View, ImageBackground, useWindowDimensions } from "react-native";
import useStyles from "./styles.css";
import BannerContent from "./banner-content";
import { tabletSize } from "@src/utils/screensize-helper";

// const { width: SCREEN_WIDTH } = Dimensions.get("window");

type Props = {
  image: any; // Should be a static image require() object
  title: string;
  description: string;
  button: any;
};

const BannerBackground = ({ image, title, description, button }: Props) => {
  const styles = useStyles();
  const { width } = useWindowDimensions();
  const drawerEnable = useAppSelector(selectedDrawerStatus);
  const isTablet = tabletSize();

  // colorPrimary: "#2B4A69",//"#253A60",
  // colorPrimary2: "#3C6FA2",
  return (
    <ImageBackground
      source={image}
      resizeMode="cover"
      style={[styles.i_bg_img_four,   {
        width: isTablet ? width : width * .95,  //isTablet ? undefined : width * 0.58,
        backgroundColor: "#2B4A69",
      }]}
    >
      <View style={{
        width: drawerEnable ? width * .7 : width *.8,
        //alignItems: 'center',
        alignSelf: "center",
        left: isTablet ? 0 : drawerEnable ? -(width *.06) :  -(width *.009),
      }}>
        <BannerContent title={title} description={description} button={button} />

      </View>
    </ImageBackground>
  );
};

export default BannerBackground;
